import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { TeamName } from "../../../components/Typography";
import query from "../../../query";
import { isGoodTeam } from "../../../utils/isGoodTeam";
import Button from "./NewButton";
import useOddChangeDetector from "../../../hooks/useOddChangeDetector";
import { convertOdds } from "../../../utils/convertOdds";
import { convertHDP } from "../../../utils/convertHDP";
import { cleanCornerId } from "../../../utils/cleanConnerId";
import Badge from "../../../components/Badge";
import classnames from "classnames";
import { useSearchParams } from "react-router-dom";
import classNames from "classnames";
import { Match } from "../../../types/feed";
import { CONFIG } from "../../../config";
import {
  ShareIcon,
  Monitoring,
  Clock,
  LiveTVV2,
} from "../../../components/sport-table/icons";
import Flag from "../../../components/sport-table/flag";

export type TableMobileProps = {
  match: Match;
  type: "live" | "today" | "early";
  onClickOddPrice?: (payload1: any) => (payload2: any) => void;
  onClickMore?: () => void;
  isFlagVisible?: boolean;
  various?: "normal" | "message";
  onClickShare?: () => void;
};

const NewMatchTable: FC<
  TableMobileProps & {
    sport:
      | "football"
      | "basketball"
      | "volleyball"
      | "tabletennis"
      | "handball"
      | "icehockey"
      | "tennis"
      | "snooker"
      | "baseball"
      | "rugby"
      | "americanfootball"
      | "cricket"
      | "badminton"
      | "boxing"
      | "bull_fight"
      | "cock_fight";

    leagueId: string;
  }
> = ({
  sport,
  match,
  type,
  onClickOddPrice,
  leagueId,
  onClickMore,
  isFlagVisible,
  various = "normal",
  onClickShare,
}) => {
  const { i18n, t } = useTranslation();
  const [_searchParams, setSearchParams] = useSearchParams();
  const [isCollapse, setIsCollapse] = useState(false);
  const isLive = type === "live";
  const isToday = type === "today";
  const betPriceKey = isLive ? "bpl" : "bp";
  const ou = match?.[betPriceKey]?.[0]?.ou;
  const betTicketInfoPayloadQuery = query.betTicketInfoPayload();
  const betTicketInfoPayload = useQuery(
    betTicketInfoPayloadQuery.key,
    betTicketInfoPayloadQuery.queryFn,
    { refetchOnMount: false, keepPreviousData: true },
  );

  const oddsTypeQuery = query.oddsType();
  const oddsType = useQuery(oddsTypeQuery.key, oddsTypeQuery.queryFn, {
    refetchOnMount: false,
    keepPreviousData: true,
  });

  const { homePriceChangedType, awayPriceChangedType } = useOddChangeDetector({
    homeHandicap: ou?.o || "",
    awayHandicap: ou?.u || "",
    homePrice: ou?.op || "0",
    awayPrice: ou?.up || "0",
    type: "ou",
  });

  const handle = onClickOddPrice?.({
    matchId: `${match.k}`,
    homeName: match.n[i18n.language as string]?.h,
    awayName: match.n[i18n.language as string]?.a,
    fhid: match.n.fhid,
    faid: match.n.faid,
    fhimg: match.n?.fhimg,
    faimg: match.n?.faimg,
  });

  return (
    <>
      <div className="bg-white mb-2 mx-2 rounded-md">
        <div
          className={classNames("w-full", {
            flex: various === "message",
          })}
          onClick={
            various === "message" ?
              () => {
                onClickMore?.();
                setSearchParams({
                  leagueId,
                  matchId: `${match.k}`,
                  sport,
                  type,
                  isFlagVisible: isFlagVisible ? "true" : "",
                });
                setIsCollapse(!isCollapse);
              }
            : undefined
          }>
          <div
            style={{ borderColor: "inherit" }}
            className="flex pl-2 w-full border-b">
            <div className="flex-1 flex flex-col py-1 gap-y-1">
              <div className="flex items-center w-full">
                {isLive && (
                  <b
                    className={classnames("mr-2", {
                      "text-green-600": Number(match.i.h) > Number(match.i.a),
                    })}>
                    {match.i.h}
                  </b>
                )}
                <div className="flex flex-1 items-center gap-x-2">
                  {isFlagVisible && (
                    <Flag
                      type="teams"
                      src={match.n?.fhimg}
                      flagId={match.n?.fhid}
                    />
                  )}

                  <TeamName
                    className="flex items-center text-sm pr-2"
                    isGoodTeam={isGoodTeam(match?.[betPriceKey]?.[0]?.ou?.o)}>
                    {match.n[i18n.language as string]?.h}
                  </TeamName>
                  {!!match?.i?.hrc &&
                    match?.i?.hrc !== "NaN" &&
                    match?.i?.arc !== "0" && (
                      <span className="">
                        {Array.from({
                          length: Number(match?.i?.hrc),
                        }).map((_each, index) => (
                          <img
                            key={index}
                            className="inline"
                            src="/red.png"
                            alt="red-card"
                            width={16}
                          />
                        ))}
                      </span>
                    )}
                </div>
              </div>
              <div className="flex items-center w-full">
                {isLive && (
                  <b
                    className={classnames("mr-2", {
                      "text-green-600": Number(match.i.a) > Number(match.i.h),
                    })}>
                    {match.i.a}
                  </b>
                )}
                <div className="flex flex-1 items-center  gap-x-2">
                  {isFlagVisible && (
                    <Flag
                      type="teams"
                      src={match.n?.faimg}
                      flagId={match.n?.faid}
                    />
                  )}

                  <TeamName
                    className="flex items-center text-sm pr-2"
                    isGoodTeam={isGoodTeam(match?.[betPriceKey]?.[0]?.ou?.u)}>
                    {match.n[i18n.language as string].a}
                  </TeamName>

                  {!!match?.i?.arc &&
                    match?.i?.arc !== "NaN" &&
                    match?.i?.arc !== "0" && (
                      <span className="">
                        {Array.from({
                          length: Number(match?.i?.arc),
                        }).map((_each, index) => (
                          <img
                            key={index}
                            className="inline"
                            src="/red.png"
                            alt="red-card"
                            width={16}
                          />
                        ))}
                      </span>
                    )}
                </div>
              </div>
            </div>
            {typeof ou?.op === "string" && various !== "message" && (
              <div className="flex">
                <Button
                  isDisabled={!ou?.op}
                  className="w-16 border-l"
                  priceChangedType={homePriceChangedType}
                  isActive={betTicketInfoPayload?.data?.some(
                    (ticket: any) =>
                      ticket.matchId === `${match.k}` &&
                      ticket.betType === "ou" &&
                      ticket.riskLevel === 0 &&
                      ticket.option === 0,
                  )}
                  hdp={`${t("Over")} ${convertHDP(ou?.o, false)}`}
                  price={convertOdds(Number(ou?.op), oddsType.data)}
                  onClick={() => {
                    handle?.({
                      option: 0,
                      riskLevel: 0,
                      betType: "ou",
                      isHomeGood: isGoodTeam(ou?.o),
                      isAwayGood: isGoodTeam(ou?.u),
                      outcomeId: ou.oco,
                      specifiers: ou.sp,
                      marketId: ou.mkid,
                    });
                  }}
                />
                <Button
                  isDisabled={!ou?.up}
                  className="w-16 border-l"
                  priceChangedType={awayPriceChangedType}
                  isActive={betTicketInfoPayload?.data?.some(
                    (ticket: any) =>
                      ticket.matchId === `${match.k}` &&
                      ticket.betType === "ou" &&
                      ticket.riskLevel === 0 &&
                      ticket.option === 1,
                  )}
                  hdp={`${t("Under")} ${convertHDP(ou?.u, false)}`}
                  price={convertOdds(Number(ou?.up), oddsType.data)}
                  onClick={() => {
                    handle?.({
                      option: 1,
                      riskLevel: 0,
                      betType: "ou",
                      isHomeGood: isGoodTeam(ou?.o),
                      isAwayGood: isGoodTeam(ou?.u),
                      outcomeId: ou.ocu,
                      specifiers: ou.sp,
                      marketId: ou.mkid,
                    });
                  }}
                />
              </div>
            )}
          </div>
          <div
            className={classNames("w-full flex justify-between", {
              "flex-col": various === "message",
            })}>
            <div
              className={classNames("flex items-center gap-x-4", {
                "justify-end": various === "message",
              })}>
              <div className="flex items-center px-2 pt-1 pb-1">
                {isLive ?
                  <span className="relative flex h-2 w-2 mr-1">
                    <span className="absolute animate-ping w-2 h-2 rounded-full bg-rose-500" />
                    <span className="w-2 h-2 rounded-full bg-rose-500" />
                  </span>
                : various === "normal" && <Clock className="mr-1" size={16} />}
                <span className="text-xs min-w-[48px] inline-block">
                  {isLive ?
                    match.i.lt
                  : isToday ?
                    moment(match.od).format("HH:mm")
                  : moment(match.od).format("ddd DD/MM HH:mm")}
                </span>
              </div>

              {!!match.st && various !== "message" && (
                <a href={match.st} target="_blank" rel="noreferrer">
                  <Monitoring size={16} />
                </a>
              )}
              {match.isChannel && various !== "message" && (
                <a
                  href={`https://askmebet.live/${
                    i18n.language as string
                  }/match/${cleanCornerId(match.k)}`}
                  target="_blank"
                  rel="noreferrer">
                  <LiveTVV2 size={16} />
                </a>
              )}

              {onClickShare && (
                <button type="button" onClick={onClickShare}>
                  <ShareIcon size={16} />
                </button>
              )}

              {Boolean(match.tip) && (
                <a
                  rel="noreferrer"
                  href={`https://askmetips.com/${i18n.language}/${sport}/${match.k}?link=${CONFIG.BASE_URL}/${sport}/${type}?matchId=${match.k}`}
                  target="_blank">
                  <img width={60} height={15} src="/askmetips.gif" alt="tips" />
                </a>
              )}
            </div>
            {!!match?.[betPriceKey]?.length && (
              <div
                className={classNames("flex", {
                  "justify-end": various === "message",
                })}>
                <div
                  className={classNames("font-bold flex relative", {
                    "justify-center border-l items-center pl-7":
                      various === "normal",
                    "justify-end px-2 py-2": various === "message",
                  })}
                  style={various === "normal" ? { width: 128 } : undefined}
                  onClick={() => {
                    onClickMore?.();
                    setSearchParams({
                      leagueId,
                      matchId: `${match.k}`,
                      sport,
                      type,
                      isFlagVisible: isFlagVisible ? "true" : "",
                    });
                    setIsCollapse(!isCollapse);
                  }}>
                  {various === "normal" && (
                    <div className="text-xs mr-2 flex items-center">
                      {t("More")}
                    </div>
                  )}
                  <Badge className="px-1 flex items-center">
                    {various === "normal" && "+"}
                    {Math.abs(
                      new Set(
                        match?.[betPriceKey]?.reduce(
                          (total: Array<string>, current: Record<any, any>) => [
                            ...total,
                            ...Object.keys(current),
                          ],
                          [],
                        ),
                      ).size +
                        (CONFIG.IS_DISABLED_SPECIAL ? 0 : (
                          Number(match.msp || 0)
                        )),
                    )}
                  </Badge>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewMatchTable;
